import React from 'react';

export const DrawerSideBoxContent: React.FC<React.PropsWithChildren> = ({ children }) => (
  <div className="flex flex-col flex-nowrap flex-grow">{children}</div>
);
